const addGoogleDirections = function({
  formSelector = '#frm-directions',
  submitSelector = 'btn-directions',
  inputSelector = 'txt-directions-postcode',
} = {}) {
  const txtBox = document.getElementById(inputSelector);

  const getDirections = function(el) {
    const latitude = el.getAttribute('data-latitude');
    const longitude = el.getAttribute('data-longitude');
    const postcode = latitude + ', ' + longitude;
    let link = 'https://www.google.com/maps/dir/';
    link += txtBox.value + '/' + postcode;
    window.open(link, '_blank') || window.location.replace(link);
  };

  const forms = document.querySelectorAll(formSelector);

  forms.forEach(function(item) {
    item.addEventListener('submit', function(event) {
      event.preventDefault();
      const el = item.querySelector('#' + submitSelector);
      getDirections(el);
    });

    const btn = item.querySelector('#' + submitSelector);
    btn.addEventListener('click', function(event) {
      event.preventDefault();
      getDirections(btn);
    });
  });
};

export default addGoogleDirections;
